declare global {
    interface Window {
        __CONFIG__?: {
            cmUrl?: string;
            oauthTokenUrl?: string;
            internalApiUrl?: string;
        };
    }
}

export type Environment = {
    cmUrl: string;
    oauthTokenUrl: string;
    internalApiUrl: string;
    cid: string;
    pid: string;
    user: string;
    pass: string;

    local: boolean;
    localStreamingUrl: string;
    localStreamingToken: string;

    debug: boolean;

    chaosNoPlaylist: boolean;
    chaosEmptyPlaylist: boolean;
    chaosNoContent: number;
    chaosContentFailEarly: number;
    chaosForceSafearea: boolean;
    chaosForceTemplate: string;
    chaosNoNextLayer: number;
};

const cmUrl = (
    window.__CONFIG__?.cmUrl ||
    import.meta.env.VITE_CM_URL ||
    'https://api.livespotting.com'
).replace(/\/+$/, '');

const env: Environment = {
    cmUrl,
    oauthTokenUrl:
        window.__CONFIG__?.oauthTokenUrl ||
        import.meta.env.VITE_OAUTH_TOKEN_URL ||
        new URL('/token', cmUrl).href,
    internalApiUrl: (
        window.__CONFIG__?.internalApiUrl ||
        import.meta.env.VITE_INTERNAL_API_URL ||
        new URL('/internal-api/v1', cmUrl).href
    ).replace(/\/+$/, ''),
    cid: import.meta.env.VITE_CID || '',
    pid: import.meta.env.VITE_PID || '',
    user: import.meta.env.VITE_USER || '',
    pass: import.meta.env.VITE_PASS || '',

    local: import.meta.env.VITE_LOCAL == 'true',
    localStreamingUrl: import.meta.env.VITE_LOCAL_STREAMING_URL || '',
    localStreamingToken: import.meta.env.VITE_LOCAL_STREAMING_TOKEN || '',

    debug: import.meta.env.VITE_DEBUG == 'true',

    chaosNoPlaylist: import.meta.env.VITE_CHAOS_NO_PLAYLIST == 'true', // whether loading a playlist fails
    chaosEmptyPlaylist: import.meta.env.VITE_CHAOS_EMPTY_PLAYLIST == 'true', // whether the playlist is empty
    chaosNoContent: parseFloat(import.meta.env.VITE_CHAOS_NO_CONTENT || '0'), // number between [0,1]: percent of Client.getContent fails
    chaosContentFailEarly: parseFloat(
        import.meta.env.VITE_CHAOS_CONTENT_FAIL_EARLY || '0',
    ), // number between [0,1]: percent of active playbacks fail early
    chaosForceSafearea: import.meta.env.VITE_CHAOS_FORCE_SAFEAREA == 'true', // whether to show the safearea
    chaosForceTemplate: import.meta.env.VITE_CHAOS_FORCE_TEMPLATE || '', // force an overlay template
    chaosNoNextLayer: parseFloat(
        import.meta.env.VITE_CHAOS_NO_NEXT_LAYER || '0',
    ), // number between [0,1]: percent of case where there's no next layer to switch to
};

export default env;
